import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import { range } from "lodash";
import AvailabilityTable from "components/menu/profile/availabilityTable";
import {
    profileGetGeneralAvailability,
    profileGetSpecialById,
    profileCreateSpecial,
    profileUpdateSpecial,
    profileDeleteSpecial
} from "api/menu/profile/actions";

const SpecialAvailabilityDaysModal  = (props) => {
    const timeFormat = "h:mm A";

    const model = {
        availableHours: 0,
        desiredHours: 0,
        end: null,
        endTicks: null,
        start: null,
        startTicks: null
    };

    const {
        onCancel,
        id,
        profileGetGeneralAvailability,
        profileGetSpecialById,
        profileUpdateSpecial,
        profileCreateSpecial,
        profileDeleteSpecial,
        generalAvailability,
        singleSpecialAvailability,
        date
    } = props;

    const defaultStateDailyAvailabilities = {};
    range(0, 7).forEach((day) => {
        defaultStateDailyAvailabilities[day] = model;
    });

    const [userGeneralAvailability, setUserGeneralAvailability] = useState({
        startDate: moment(date).startOf("week").format(moment.defaultFormat),
        endDate: moment(date).endOf("week").startOf("day").format(moment.defaultFormat),
        dailyAvailabilities: defaultStateDailyAvailabilities,
    });

    useEffect(() => {
        if (id) {
            profileGetSpecialById(id);
        } else {
            profileGetGeneralAvailability();
        }
    }, [id, profileGetSpecialById, profileGetGeneralAvailability]);

    useEffect(() => {
        if (Object.keys(singleSpecialAvailability).length) {
            setUserGeneralAvailability(singleSpecialAvailability);
        } else if (!id) {
            // eslint-disable-next-line guard-for-in,no-restricted-syntax
            for (const dayIndex in generalAvailability.dailyAvailabilities) {
                generalAvailability.dailyAvailabilities[dayIndex].desiredHours = 0;
            }
            setUserGeneralAvailability({
                ...userGeneralAvailability,
                dailyAvailabilities: generalAvailability.dailyAvailabilities
            });
        }
    }, [singleSpecialAvailability, generalAvailability, id]);

    useEffect(() => {
        return () => {
            profileGetGeneralAvailability(true);
            profileGetSpecialById(false);
        };
    }, [profileGetGeneralAvailability]);

    const onChangeTime = (dayOfWeek, key, time) => {
            const newState = Object.assign({}, userGeneralAvailability);
            newState.dailyAvailabilities = Object.assign({}, newState.dailyAvailabilities);
            newState.dailyAvailabilities[dayOfWeek] =
                Object.assign({}, newState.dailyAvailabilities[dayOfWeek]);
            newState.dailyAvailabilities[dayOfWeek][key] = time
                ? moment(time).format(timeFormat)
                : null;
            setUserGeneralAvailability(newState);
        },
        onChangeHours = (dayOfWeek, key, hours) => {
            const newState = Object.assign({}, userGeneralAvailability);
            newState.dailyAvailabilities = Object.assign({}, newState.dailyAvailabilities);
            newState.dailyAvailabilities[dayOfWeek] =
                Object.assign({}, newState.dailyAvailabilities[dayOfWeek]);
            newState.dailyAvailabilities[dayOfWeek][key] = hours;
            setUserGeneralAvailability(newState);
        },
        handleSave = () => {
            if (id) {
                profileUpdateSpecial(id, userGeneralAvailability, onCancel);
            } else {
                profileCreateSpecial(userGeneralAvailability, onCancel);
            }
        },
        handleDelete = () => {
            profileDeleteSpecial(id, onCancel);
        };

    const isEditable = moment(date)
        .endOf("week")
        .startOf("day")
        .valueOf() > moment().valueOf();
    const showDeleteButton = id && isEditable;

    return (
        <div>
            <AvailabilityTable
                data={userGeneralAvailability.dailyAvailabilities || {}}
                onChangeHours={onChangeHours}
                onChangeTime={onChangeTime}
            />

            <div className={`text-right d-flex ${showDeleteButton ? "justify-content-between" : "justify-content-end"}`}>
                {showDeleteButton ?
                <button
                    className="btn btn-danger"
                    onClick={handleDelete}
                >
                    Delete
                </button>
                : null}

                <button
                    className="btn btn-success"
                    onClick={handleSave}
                    disabled={!isEditable}
                >
                    Save
                </button>
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    loading: state.profile.loading,
    generalAvailability: state.profile.generalAvailability,
    singleSpecialAvailability: state.profile.singleSpecialAvailability
});

const mapStateToDispatch = dispatch => ({
    profileGetGeneralAvailability: bindActionCreators(profileGetGeneralAvailability, dispatch),
    profileGetSpecialById: bindActionCreators(profileGetSpecialById, dispatch),
    profileCreateSpecial: bindActionCreators(profileCreateSpecial, dispatch),
    profileUpdateSpecial: bindActionCreators(profileUpdateSpecial, dispatch),
    profileDeleteSpecial: bindActionCreators(profileDeleteSpecial, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(SpecialAvailabilityDaysModal);
